(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/components/fractiongames/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/keno/components/fractiongames/assets/javascripts/prescript.js');

'use strict';

svs.keno = svs.keno || {};
svs.keno.components = svs.keno.components || {};
svs.keno.components.fractiongames = svs.keno.components.fractiongames || {};
svs.keno.components.fractiongames.views = svs.keno.components.fractiongames.views || {};

 })(window);